import { MultiStrikeChartTypes } from '../../reducer/multiStrikeChart.reducer'

/** Migrate legacy oi + showChange configs to the dedicated oiChange type. */
export function normalizeMultiStrikeChartType(
    chartType: MultiStrikeChartTypes | undefined,
    showChange?: boolean
): MultiStrikeChartTypes {
    if (chartType === 'oi' && showChange) {
        return 'oiChange'
    }
    return chartType ?? 'iv'
}

export function isOiValueChartType(chartType: MultiStrikeChartTypes): boolean {
    return chartType === 'oi' || chartType === 'oiChange' || chartType === 'cumOi'
}

export function isAbsoluteOiChartType(chartType: MultiStrikeChartTypes): boolean {
    return chartType === 'oi' || chartType === 'cumOi'
}

export function showsCumOiToggle(chartType: MultiStrikeChartTypes): boolean {
    return chartType === 'oi' || chartType === 'oiChange' || chartType === 'cumOi'
}

/** Map cumOi (+ change mode) to the chart-type menu value. */
export const getMultiStrikeChartTypeMenuValue = (
    chartType: MultiStrikeChartTypes,
    cumOi: boolean,
    showChange?: boolean
): 'price' | 'iv' | 'oi' | 'oiChange' => {
    if (chartType === 'cumOi') {
        return showChange ? 'oiChange' : 'oi'
    }
    if (chartType === 'oi' && cumOi) {
        return 'oi'
    }
    if (chartType === 'oiChange') {
        return 'oiChange'
    }
    return chartType as 'price' | 'iv' | 'oi' | 'oiChange'
}

export function resolveCumOiToggleState(
    checked: boolean,
    currentChartType: MultiStrikeChartTypes,
    showChange?: boolean
): { chartType: MultiStrikeChartTypes; cumOi: boolean; showChange: boolean } {
    if (checked) {
        const usesChange = currentChartType === 'oiChange' || (currentChartType === 'cumOi' && showChange)
        return {
            chartType: 'cumOi',
            cumOi: true,
            showChange: usesChange,
        }
    }
    const returnToOiChange = currentChartType === 'cumOi' && showChange
    return {
        chartType: returnToOiChange ? 'oiChange' : 'oi',
        cumOi: false,
        showChange: false,
    }
}
